import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
// The below is a fix for https://ecosystem-platform.atlassian.net/browse/EXT-2328
// The cursor always jumps to the end of the input field when the value changes due
// the runtime passing the forgedoc back to the product asynchronously.
// The workaround here is to store the last cursor position in state
// Check if this is still an issue when all products have moved to react-18
export var useCursorState = function useCursorState(value, onChange) {
  var inputRef = React.useRef(null);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    cursor = _React$useState2[0],
    setCursor = _React$useState2[1];
  React.useEffect(function () {
    var input = inputRef.current;
    if (input && cursor !== null && input.selectionStart !== cursor) {
      input.setSelectionRange(cursor, cursor);
    }
  }, [inputRef, cursor, value]);
  var onChangeWithCursorState = React.useCallback(function (e) {
    onChange === null || onChange === void 0 || onChange(e);
    if (e.target.selectionStart) {
      var _e$target;
      setCursor((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.selectionStart);
    }
  }, [onChange]);
  if (!onChange) {
    return {
      onChangeWithCursorState: undefined,
      inputRef: inputRef
    };
  }
  return {
    onChangeWithCursorState: onChangeWithCursorState,
    inputRef: inputRef
  };
};